import {
  createSlice,
  PayloadAction,
  // createAsyncThunk,
  // createDraftSafeSelector,
} from "@reduxjs/toolkit";
import store, { RootState } from "store";

interface IInitialState {
  query: any,
  visible: boolean
  list: any[],
}

const initialState: IInitialState = {
  query: {},
  visible: false,
  list: []
};

export const knowledgeSlice = createSlice({
  name: "knowledge",
  initialState: initialState,
  reducers: {
    setQuery: (state, action: PayloadAction<any>) => {
      state.query = action.payload;
    },
    setList: (state, action: PayloadAction<any>) => {
      state.list = action.payload;
    },
    setVisible: (state, action: PayloadAction<any>) => {
      state.visible = action.payload;
    }
  },
});

export const mapKnowledgeQuery = (state: RootState) => state.knowledge.query;
export const mapKnowledgeList = (state: RootState) => state.knowledge.list;
export const mapKnowledgeVisible = (state: RootState) => state.knowledge.visible;
export const { setList, setVisible, setQuery } = knowledgeSlice.actions;

// 设置弹窗
export const setKnowledgeVisible = (visible: boolean) => {
  const dispatch = store.dispatch;
  dispatch(setVisible(visible))
};

export const setKnowledgeList = (list: any[]) => {
  const dispatch = store.dispatch;
  dispatch(setList(list))
};
export const setKnowledgeQuery = (data: any) => {
  const dispatch = store.dispatch;
  dispatch(setQuery(data))
};

export default knowledgeSlice.reducer;
